import styled from '@emotion/styled'

export const TipButtonsContainerStyled = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
  columnGap: '0.5rem',
})
